import { useEffect, useState } from "react";
import { API_ENDPOINTS } from "../utils/api-endpoints";
import { axiosFunction } from "../utils/globalFunctions/axiosFunction";
import { ReactProjectBaseUrl } from "../utils/Constants";
import { getApiToken } from "../utils/get-token";

const useUpdateSettings = () => {
  const [settingsData, setSettingsData] = useState([]);
  const token = getApiToken();
  const fetchUpdateSettings = async () => {
    const res = await axiosFunction(
      token,
      ReactProjectBaseUrl + API_ENDPOINTS.UPDATE_SETTINGS,
      "GET"
    );

    if (res.data.status) {
      setSettingsData(res.data.response);
    } else {
      setSettingsData([]);
    }
  };

  useEffect(() => {
    setTimeout(() => {
      fetchUpdateSettings();
    }, 500);
  }, [token]);

  return { settingsData };
};

export default useUpdateSettings;
